import { render } from "./TodoCardEntrega.vue?vue&type=template&id=7fdb06c0"
import script from "./TodoCardEntrega.vue?vue&type=script&lang=js"
export * from "./TodoCardEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__